export default __webpack_public_path__ + "static/media/480_store01-it-web.0f194d25.png";